import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TratamientosService } from 'src/app/services/tratamientos.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'tratamiento',
  templateUrl: './tratamiento.component.html',
})

export class TratamientoComponent {

  public id_tratamiento = null;
  public tratamiento = null;
  public identity = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _tratamientoService: TratamientosService,
  ){

  }

  ngOnInit(){
    this._route.params.forEach((params:Params) => {
      this.id_tratamiento = params['id'];
      this.id_tratamiento = ( isNaN( parseInt( this.id_tratamiento ) ) ) ? null : parseInt( this.id_tratamiento );
      this.obtenerTratamiento();
    });
  }

  obtenerTratamiento(){
    if( this.id_tratamiento != null){
      this.spinner.show('spnr-s');
      let respuesta = this._tratamientoService.obtenerTratamiento( this.id_tratamiento );
      respuesta.then( val =>{
        this.spinner.hide('spnr-s');
        if( val.status == "success" ){
          if(val.tratamiento != null ){
            this.tratamiento = val.tratamiento;
          }else{
            this._router.navigate(['/tratamientos']);
          }
        }else{
          Swal.fire({
            title: 'Oopss...',
            text: val.message,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });
          this._router.navigate(['/tratamientos']);
        }
      },
      error =>{
        Swal.fire({
          title: 'Oopss...',
          text: error,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#1beb11',
        });
        this.spinner.hide('spnr-s');
      });
    }else{
      this.spinner.hide('spnr-s');
      this._router.navigate(['/tratamientos']);
    }
  }

}
